import { Injectable } from "@angular/core";
import { DemoModuleEndPoints } from "src/app/utils/constants/demo-mode/demo-module-endpoints.constants";

@Injectable({ providedIn: 'root' })
export class DemoModuleService {
  getDemoConfig(moduleName: string, urlPath: string) {
    const moduleMap = DemoModuleEndPoints[moduleName] as any;
    if (!moduleMap) return null;

    const matchedKey = Object.keys(moduleMap).find(key => {
      const isMatch = urlPath.includes(key);
      return isMatch;
    });
    if (!matchedKey) return null;

    return {
        data: moduleMap[matchedKey].data,
        normalize: moduleMap[matchedKey].normalize || false,
        matchedKey
    };
  }

}
